import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import MDInput from "components/MDInput";
import { FormControl, InputLabel, MenuItem, Pagination, Select } from "@mui/material";
import moment from "moment";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { useIsMobile } from "hooks/useIsMobile";
import TotalsView from "components/totals_view";
import { getPaymentHistoryCall } from "api/api";
import getPaymentHistoryTableData from "./data/table_data";
const limit = 8;

const settleOptions = [
  { label: "Any", value: "-1" },
  { label: "Settled", value: true },
  { label: "Not Settled", value: false },
];

function PaymentHistory() {
  const [state, setState] = useState({
    columns: [],
    rows: [],
    fromDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    settled: settleOptions[0].value,
    page: 1,
    totalPages: 1,
    totalSettledAmount: "",
    totalNotSettledAmount: "",
  });

  const isMobile = useIsMobile();

  const getPaymentHistory = async ({ fromDate, toDate, page, settled }) => {
    const response = await getPaymentHistoryCall({ fromDate, toDate, page, settled, limit });
    if (response) {
      const { totalSettledAmount, totalNotSettledAmount, page } = response;
      const { columns, rows } = getPaymentHistoryTableData(response.data);
      setState({
        ...state,
        columns,
        rows,
        page,
        totalPages: response.total_pages,
        totalSettledAmount,
        totalNotSettledAmount,
      });
    }
  };

  useEffect(() => {
    const { fromDate, toDate, settled, page } = state;
    getPaymentHistory({ fromDate, toDate, settled, page });
  }, [state.fromDate, state.toDate, state.settled, state.page]);

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
                gap={isMobile ? 1 : 0}
              >
                <MDTypography variant="h6" color="white">
                  Payment History
                </MDTypography>
                <MDBox display="flex" flexDirection={isMobile ? "column" : "row"} gap={1}>
                  <TotalsView
                    title={"Settled"}
                    amount={state.totalSettledAmount}
                    variant="success"
                  />
                  <TotalsView
                    title={"Not Settled"}
                    amount={state.totalNotSettledAmount}
                    variant="error"
                  />
                </MDBox>
              </MDBox>
              <MDBox display="flex" gap={2} bgColor="white" px={2} mt={4} borderRadius="lg">
                <MDInput
                  label="From"
                  type="date"
                  value={state.fromDate}
                  fullWidth
                  onChange={(e) => {
                    setState({ ...state, fromDate: e.target.value });
                  }}
                />
                <MDInput
                  label="To"
                  type="date"
                  value={state.toDate}
                  fullWidth
                  onChange={(e) => {
                    setState({ ...state, toDate: e.target.value });
                  }}
                />

                <FormControl fullWidth>
                  <InputLabel>Settle Status</InputLabel>
                  <Select
                    value={state.settled}
                    label="Settle Status"
                    onChange={(event) => {
                      setState({ ...state, settled: event.target.value });
                    }}
                    style={{
                      paddingBottom: "0.75rem",
                      paddingTop: "0.75rem",
                    }}
                  >
                    {Object.values(settleOptions).map(({ label, value }, index) => (
                      <MenuItem key={index} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: state.columns, rows: state.rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <Pagination
                  style={{
                    justifySelf: "right",
                    margin: 10,
                  }}
                  variant="outlined"
                  shape="rounded"
                  count={state.totalPages}
                  page={state.page}
                  onChange={(e, page) => {
                    setState({ ...state, page });
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default PaymentHistory;
